const NEWWAY_WEB_CLIENT_APP_VERSION = "1.1.0";

export {NEWWAY_WEB_CLIENT_APP_VERSION};
